import React from "react";
import { useState,useEffect } from "react";
import { configData } from "../config";
import { Link, useNavigate,useLocation,useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Loading from './Loading';

import AgentBackendSidebar from './AgentBackendSidebar';

/* const agentAccount = {
    smwwMail:"",
    name:"TestKrishna Roja",
    personalMail:"Krishnaroja@gmail.com",
    publicProfile: "https://www.smwwagency.com/agent/testkrishna-rojatest",
} */

const AgentHome = ({userLoggedInRoles, uid}) => {

    const [isLoading, setIsLoading] = useState(true); 
    const [agentAccount, setAgentAccount] = useState({});
    const [showcontent,setShowContent] = useState(true);
    const location  = useLocation();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;
    // var {uid} = useParams();
    //  var {username} = useParams();
    // if(location.state) {
    //     uid = location.state;
    // }

    useEffect(() => {
                  Promise.all([
                      checkpermissionforpageaccess()
                  ])
                  .then(() => {
               
                  setIsLoading(false);
                  })
               
              },[]);
               async function checkpermissionforpageaccess() {
        
           
                const response = await fetch(
                     app_url+'smwwagency/checkpermissionforhomepageaccess?uid='+loggedin_uid,
                    {
                        method: "GET",
      
                        headers: {
                        'Content-Type': 'application/json',
                        },
                    }
                )           
                const responsedata = await response.json();
                if(responsedata.data.msg === "Success") {
                    setShowContent(true);
                } 
                 if(responsedata.data.msg === "Error") {
                   setShowContent(false);
                } 
    
           
        }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div>

                    {(userLoggedInRoles.includes(configData.ROLE_SCOUT) && 
                    !(userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) || userLoggedInRoles.includes(configData.ROLE_SAADMIN)
                    || userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))) && ( 
                        <div style={{fontWeight: "bold", background: "bisque", padding: "10px", marginBottom: "10px"}}>
                            Trying to access your SMWW Scout account? 
                            <a href={"https://"+configData.RSMWW_SCOUT_DOMAIN+"/user/"+uid} target="_blank" style={{color: "#2c99d2"}}> Click here</a>.
                        </div>
                    )} 

                    {showcontent ? (
                        <>
                    <h1>Welcome to SMWW Agency! We have athletes for you to represent.</h1>

<p style={{ textAlign: 'center', fontSize: 18, margin: '14px 0px' }}>
	By accepting to represent this athlete you accept to incur 
	any expenses at your own risk.<br />
	You agree to split the commission with SMWW as defined in 
	our contractual agreement
	</p>
        
<p>As an SMWW Agent Advisor you can choose one of <a href="/pending_athletes">these</a> athletes 
	from the following list every 12 hours.  This is to ensure that 
	athletes are distributed equally.  As athletes register on the 
	SMWW website they will be added to <a href="/pending_athletes">this list</a> and you are invited 
	to represent them.  All the athlete has received from SMWW is a 
	standard automated response thanking them for applying and that 
	an Agent Advisor will be contacting them.<br /><br />
	
	By choosing to represent an athlete, you are taking on the 
	responsibility of representing SMWW and professionally contacting 
	this athlete within 24 hours of committing to the athlete on this 
	list.  We recommend you call and introduce yourself as an Agent 
	from SMWW, and offer to assist the athlete with their career. <br /><br /> 

	If you have any questions about the ability of your athlete or 
	need advice please contact the Sport Director of 
	the sport your athlete is playing and he/she will direct you to 
	the appropriate resources.</p>
<p>Remember you represent Sports Management Worldwide and our motto is even if this athlete isn't a superstar, their brother, sister, or roommate might be. And please be aware that some of these athletes might "embellish" their playing skills. Always treat them with the utmost respect. If they do not have the ability to "play” sports professionally, you might suggest they look to us to "work" in sports. We will have a few athletes who register who are really interested in SMWW courses but filled out the wrong application, so in this event, please direct them back to our website.
<br /><br /> 

	Becoming a professional sports agent includes the ability to help all types of athletes in all walks of life. With this listing we hope to accelerate your learning process and help you find professional athletes to represent more quickly. Most of these athletes simply need to attend a workout or combine so they can play in front of team personnel who are decision makers. We do not recommend that you pay for the athlete to attend these workouts because you can not guarantee a return on this investment. If after sending this athlete to several workouts they do not get picked up, you may not be able to help them, but we hope that you can learn from this and continue to make new contacts with teams and others in the business. Most importantly, have fun because it's all a learning experience!
<br /><br />
	
	<strong>Dr. Lynn Lashbrook</strong></p>
    </>
                    ) : (
                        <><div style={{ textAlign: 'center'}}><a id="Agent_Initiation" style={{ width:'60%' }} class="reddbtnn" href="/smww_misc_pay?lineitems=Agent_Initiation&country=">Subscribe to the SMWW Agency Program</a></div>
</>
                    )
                }
                </div>
            )}
        </>
    );
};
export default AgentHome;